import { useCallback, useRef, useState } from 'react';
import _ from 'lodash';
import { useGolfMatches } from './useGolfMatches';
import { calcMatchStatus } from '../golfCalcs/calcMatchStatus';

const _matchUpdateTime = 3000

export const userRandomMatchScoring = ({ handleAmmend_matchUpdater }) => {

  const { handleUpdate_golfMatchScore } = useGolfMatches()
  const [rmsStarted, setRmsStarted] = useState();

  const updateMatch = (match, matchStatus) => {

    const handleUpdated = () => {
      // console.group('Updated', match?._itemKey)
      // console.log(match)
      // console.log(matchStatus)
      // console.groupEnd()
      // console.groupEnd()
      // handleAmmend_matchUpdater(rm, true) 
    }

    if (!matchStatus.finished) {

      const activeHoleNumber = match?.holeWinners ? _.last(_.keys(match?.holeWinners)) : 0;
      const newHoleNumber = _.toInteger(activeHoleNumber) + 1

      const matchUpdate = {
        golfMatch: match,
        holeNumber: newHoleNumber,
        winningTeam: Math.floor(Math.random() * 3),
        playerScoring: null,
        lowScores: null
      }

      handleUpdate_golfMatchScore({ matchUpdate, matchStatus, autoScoringOn: true, callback: handleUpdated })
    }
  }

  const rmsIntervalRef = useRef(null);

  const startRandomMatchScoring = useCallback(({ golfTournament_state, teams, matches_rounds, roundsStatus, roundKey, handleStop_autoScoring }) => {

    if (rmsStarted) return;

    const { holes } = golfTournament_state ?? {}

    const currentRoundMatches = matches_rounds?.[roundKey]
    const roundStatus = roundsStatus?.[roundKey]
    const { matchStatuses } = roundStatus ?? {}

    setRmsStarted(true)

    let matchIndex = 0;

    rmsIntervalRef.current = setInterval(() => {

      const nonFinishedStatuses = _.filter(matchStatuses, { finished: false });

      if (_.isEmpty(nonFinishedStatuses)) {
        clearInterval(rmsIntervalRef.current);
        rmsIntervalRef.current = null;
        handleStop_autoScoring()
        return;
      }

      const matchStatusArray = _.sortBy(_.values(nonFinishedStatuses), 'matchNumber');

      if (matchIndex >= matchStatusArray.length) {
        clearInterval(interval);
        return;
      }

      const matchStatus = matchStatusArray[matchIndex];
      let match = currentRoundMatches?.[matchStatus?._itemKey] ?? null;

      const ms = calcMatchStatus(match, holes, teams, null, true)

      if (!ms.finished) {
        updateMatch(match, matchStatus);
      }

      matchIndex++;

      // Start over after the last match
      if (matchIndex >= matchStatusArray.length) {
        matchIndex = 0;
      }

    }, _matchUpdateTime);

  }, []);

  const stopRandomMatchScoring = useCallback(() => {
    setRmsStarted(false);
    if (rmsIntervalRef.current) {
      clearInterval(rmsIntervalRef.current);
      rmsIntervalRef.current = null;
    }
  }, []);

  return {
    startRandomMatchScoring,
    stopRandomMatchScoring,
    rmsStarted,
  };
}
